import StreamFincons from './StreamFincons.js';
import Configuration from './config/Configuration.js';

export default class Stream {
    /**
     * @param {Object} options
     * @param {String} options.authToken
     * @param {String} options.mediaId
     * @param {cast.framework.messages.StreamType} options.streamType
     * @param {Logger} logger
     * @returns {StreamFincons|null}
     */
    static getStream(options, logger) {
        logger.info(`Get Stream for type: ${Configuration.get('streamType')}`);

        if (Configuration.get('streamType') === 'fincons') {
            return new StreamFincons(options, logger);
        }
        logger.warning('Stream type not supported');
        return null;
    }
}
